import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchPaidFeeDetails = createAsyncThunk(
  "paidFee/fetchPaidFeeDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${server}/paid_fee`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching paid fee details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const paidFeeSlice = createSlice({
  name: "paidFee",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaidFeeDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchPaidFeeDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchPaidFeeDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default paidFeeSlice.reducer;
